import React from 'react';
import { Box, Grid, Button, Typography, Chip } from '@mui/material';
import { FormData } from 'src/interfaces/iproptypes';
import { COLOR_GREY_200, COLOR_GREY_400, COLOR_PRIMARY_2 } from 'src/utils/colors';

const PriceRange = ({
  formData,
  setFormData,
}: {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
}) => {
  const handlePriceRangeChange = (value: string) => {
    setFormData({ ...formData, priceRange: value });
  };

  const options = ['<$150K', '$150K-$350K', '$350K-$500K', '$500K-$750K', '$750K-$1M', '$1M+'];

  return (
    <Box>
      <Typography variant="h3" sx={{ fontSize: '24px', textAlign: 'center' }}>
        What is your price range?
      </Typography>
      <Grid container spacing={2} justifyContent="center" sx={{ mt: '20px', maxWidth: '600px' }}>
        {options.map(option => (
          <Grid item key={option}>
            <Chip
              label={option}
              variant="outlined"
              sx={{
                padding: '25px 20px',
                borderRadius: '900px',
                fontSize: '16px',
                fontWeight: 500,
                mb: '10px',
                borderColor: COLOR_GREY_400 + '55',
                borderWidth: '2px',
                ...(formData.priceRange === option && {
                  borderColor: COLOR_PRIMARY_2,
                  backgroundColor: '#E0E0E0',
                }),
              }}
              onClick={() => handlePriceRangeChange(option)}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PriceRange;
